import { createFlagElement } from './flags.js';
import {
  LANGUAGE_FLAGS,
  LANGUAGE_NAMES,
  SITE_LANGUAGE_CODES,
  getLanguageFlag,
  getLanguageName,
} from '../../js/utils/languageData.js';

const siteFlags = Object.fromEntries(
  SITE_LANGUAGE_CODES.map((code) => [code, LANGUAGE_FLAGS[code]])
);
const siteNames = Object.fromEntries(
  SITE_LANGUAGE_CODES.map((code) => [code, LANGUAGE_NAMES[code]])
);

export const LANGUAGE_DATA = {
  flags: siteFlags,
  names: siteNames,
};

export { getLanguageFlag, getLanguageName };

export const getLanguageFlags = () => LANGUAGE_DATA.flags;

/**
 * @param {{ language: string }} options
 * @returns {HTMLElement}
 */
export function createLanguageDropdown({ language }) {
  const dropdown = document.createElement('div');
  dropdown.className = 'dropdown';

  const dropbtn = document.createElement('button');
  dropbtn.type = 'button';
  dropbtn.className = 'lang-dropbtn';
  dropbtn.setAttribute('aria-label', 'Change language');

  const currentFlag = createFlagElement(getLanguageFlag(language));
  currentFlag.setAttribute('aria-label', getLanguageName(language));
  dropbtn.appendChild(currentFlag);

  const langCode = document.createElement('span');
  langCode.className = 'lang-code';
  langCode.textContent = language.toUpperCase();
  dropbtn.appendChild(langCode);

  const arrow = document.createElement('i');
  arrow.className = 'fas fa-chevron-down lang-dropdown-arrow';
  dropbtn.appendChild(arrow);

  const dropdownContent = document.createElement('div');
  dropdownContent.className = 'dropdown-content';

  SITE_LANGUAGE_CODES.forEach((code) => {
    const option = document.createElement('button');
    option.type = 'button';
    option.className = 'lang-option';
    option.dataset.lang = code;

    const flagImg = createFlagElement(LANGUAGE_DATA.flags[code]);
    flagImg.setAttribute('aria-label', getLanguageName(code));

    const langText = document.createElement('span');
    langText.className = 'lang-text';
    langText.textContent = getLanguageName(code);

    option.appendChild(flagImg);
    option.appendChild(langText);
    dropdownContent.appendChild(option);
  });

  dropdown.appendChild(dropbtn);
  dropdown.appendChild(dropdownContent);
  return dropdown;
}
